class BpayDetailsController {
  constructor() {
    this.name = 'bpayDetails'
  }
}

export default BpayDetailsController
